import script from "./add-invoices.vue?vue&type=script&setup=true&lang=js"
export * from "./add-invoices.vue?vue&type=script&setup=true&lang=js"

import "./add-invoices.vue?vue&type=style&index=0&id=07c667b2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07c667b2"]])

export default __exports__